export default __webpack_public_path__ + "static/media/organization2-blue.2c103170.svg";